import { useTranslation } from "react-i18next";
import { Box, BoxProps } from "shared/components/Spor";
import { Text } from "shared/components/typography/TitleStyles";
import styled, { RuleSet } from "styled-components";

type NoDataProps = BoxProps & {
  reason: string;
  panelStyle?: RuleSet<object>;
};

const Wrapper = styled(Box)<{ $panelStyle?: RuleSet<object> }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  height: auto;
  margin-top: 0px;
  padding: 24px 12px;
  border-radius: 6px;
  box-sizing: border-box;
  justify-content: center;
  flex: 1;
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  ${({ $panelStyle }) => $panelStyle};
`;

export const NoDataMessage = ({
  reason,
  panelStyle,
  ...props
}: NoDataProps) => {
  const { t } = useTranslation();
  return (
    <Wrapper $panelStyle={panelStyle} {...props}>
      <Text style={{ fontWeight: 600, textAlign: "center" }}>
        {t("Ingen treff")}
      </Text>
      <Box maxWidth="300px" textAlign="center">
        <Text>{reason}</Text>
      </Box>
    </Wrapper>
  );
};
